export const trackClick = (eventAction: string, eventLabel: string) =>
  window?.dataLayer?.push({
    event: "lineup_module_click",
    eventCategory: "topic_module",
    eventAction,
    eventLabel,
  });

export const trackItemClick = (
  eventAction: string,
  eventLabel: string,
  storyIndex: number
) =>
  window?.dataLayer?.push({
    event: "lineup_module_click",
    eventCategory: "hp_modules_click",
    eventAction,
    eventLabel,
    storyIndex,
  });

export const trackModuleImpression = (moduleId: string) =>
  window?.dataLayer?.push({
    event: "lineup_module_impression",
    eventCategory: "topic_module",
    eventAction: "impression",
    eventLabel: moduleId,
  });
